class Tokenizer {
  constructor() {}

  // Функция для токенизации текста
  tokenize(text: string): string[] {
    return text
      .toLowerCase()
      .replace(/[^\w\s]/g, '') // Убираем все знаки препинания
      .split(/\s+/) // Разбиваем текст на слова
      .filter(Boolean); // Убираем пустые строки
  }

  // Функция для преобразования текста в числовые векторы
  textToVector(texts: string[]): number[][] {
    const wordSet = new Set<string>();
    
    // Собираем все уникальные слова
    texts.forEach(text => {
      this.tokenize(text).forEach(word => wordSet.add(word));
    });
    
    const wordList = Array.from(wordSet);
    
    // Создаем объект, который будет сопоставлять каждому слову индекс
    const wordIndex: Record<string, number> = wordList.reduce((acc: Record<string, number>, word: string, idx: number) => {
      acc[word] = idx;
      return acc;
    }, {});

    // Преобразуем текст в вектор
    return texts.map((text: string) => {
      const vector = new Array(wordList.length).fill(0);
      this.tokenize(text).forEach((word: string) => {
        if (wordIndex[word] !== undefined) {
          vector[wordIndex[word]] = 1; // Если слово присутствует, ставим 1
        }
      });
      return vector;
    });
  }
}

export default Tokenizer;